module.exports = __webpack_public_path__ + "img/forestorytellingtour_main_03.a0946012.jpg";